
import { mapState } from 'vuex';

export default {
    name: 'AutoQuoteFormType',
    props: {
        form: {
            type: Object,
            required: true,
        },
        sizes: {
            type: Array,
            required: true,
        },
        typeKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            leadTimeOptions: [
                { slug: '1to3', text: this.$t('jobs.lead_times.1to3') },
                { slug: '3to5', text: this.$t('jobs.lead_times.3to5') },
                { slug: 'upto7', text: this.$t('jobs.lead_times.upto7') },
                { slug: '1to2week', text: this.$t('jobs.lead_times.1to2week') },
            ],
        };
    },
    computed: {
        ...mapState(['auth']),
        pricesWithVAT() {
            if (this.form.vat.$model === 'exc_vat') {
                return this.$t('jobs.prices_excluding_vat');
            }
            if (this.form.vat.$model === 'inc_vat') {
                return this.$t('jobs.prices_including_vat');
            }
            return this.$t('business.prices');
        },
    },
};
